<template>
  <esg-base-dashboard-card :title="`${corporation.name} 사업장별 온실가스 배출량`">
    <template #actions>
      <esg-base-select-box v-model="sort"
                           label="정렬"
                           size="sm">
        <option value="asc">오름차순</option>
        <option value="dsc">내림차순</option>
      </esg-base-select-box>
    </template>
    <corp-emission-by-biz-loc :corporation="corporation"
                              :sort="sort"/>
  </esg-base-dashboard-card>
</template>

<script>
import EsgBaseDashboardCard from "@/components/esg/base/EsgBaseDashboardCard.vue";
import CorpEmissionByBizLoc from "@/components/esg/3. Monitoring/charts2/CorpEmissionByBizLoc.vue";
import EsgBaseSelectBox from "@/components/esg/base/form/EsgBaseSelectBox.vue";

export default {
  name: "SelectableCorpEmissionByScope",
  components: { EsgBaseSelectBox, CorpEmissionByBizLoc, EsgBaseDashboardCard },
  props: {
    corporation: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      sort: 'dsc',
    }
  }
}
</script>